import { RunState, newRun } from "./runState";
import { EncounterZone } from "../data/encounterZones";

export type OverworldFlowState = "exploring" | "encounterVictory" | "floorVictory";

export type OverworldZoneState = EncounterZone & {
  kind: "encounter" | "boss" | "rest";
  status: "available" | "completed" | "locked";
};

export type OverworldWorldBounds = { width: number; height: number };

/**
 * State for the overworld scene, persisted across encounters.
 */
export interface OverworldState {
  /** Player's X position in world coordinates */
  playerX: number;
  /** Player's Y position in world coordinates */
  playerY: number;
  /** Current run state */
  run: RunState;
  /** Flow marker for UI and routing */
  flow: OverworldFlowState;
  /** IDs of completed encounter zones */
  completedZoneIds: Set<number>;
  /** Zones available in the overworld */
  zones: OverworldZoneState[];
  /** Active zone currently being resolved */
  activeZoneId?: number;
  /** Last zone entered (prevents immediate re-trigger while still inside) */
  lastVisitedZoneId?: number;
  /** Cached world bounds for rebuilding zone layout */
  worldBounds?: OverworldWorldBounds;
  /** Floor number the current zone layout was generated for */
  generatedForFloor?: number;
}

/**
 * Create a new overworld state with default values.
 */
export const newOverworldState = (run?: RunState): OverworldState => ({
  playerX: 0,
  playerY: 0,
  run: run ?? newRun(),
  flow: "exploring",
  completedZoneIds: new Set(),
  zones: [],
  lastVisitedZoneId: undefined,
});
